<template>
    <div id="page_Container">
        <div id="membercenter">
            <div id="main-container">
                <div class="header">
                    <div class="left">
                        <div class="title">{{details.invoiceStatusStr}}</div>
                        <div class="info">商家正在处理，如有问题请咨询客服</div>
                    </div>
                    <div class="right">
                        <img :src="imgList.invoice" alt="">
                    </div>
                </div>
                <div class="i-container">
                    <div class="invoice">
                        <div class="invoice-header"><img :src="invoiceHeader" alt=""></div>
                        <div class="invoice-container">
                            <div class="invoice-item" v-for="(item,index) in textForm" :key="index">
                                <div class="label">{{item.label}}</div>
                                <div class="value">
                                    {{item.type === 'price' && (details[item.value]|| details[item.value] === 0) ? '￥': ''}}
                                    {{details[item.value] || details[item.value] === 0? details[item.value] : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btns">
                    <van-button round type="primary" :disabled="disabled" size="large" style="margin-bottom: 15px" @click="previewPdf">预览</van-button>
                    <van-button round type="primary" :disabled="disabled" size="large" @click="openSendInvoice">发送</van-button>
                </div>
                <!-- <van-popup v-model="pdfShow">
                    <PDF
                        :src="pdfSrc">
                    </PDF>
                </van-popup> -->
            </div>
        </div>
    </div>
</template>

<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import { mapGetters } from 'vuex';
// import PDF from 'vue-pdf';
export default {
    data() {
        return {
            routerParams: {},
            pdfShow: false,
            imgList: {
                invoice: require('@/assets/img/myCenter/icon_kaipiaoshenqing@3x.png'),
                invoiceBg: require('@/assets/img/myCenter/invoiceBg@3x.png'),
                invoiceHeader: require('@/assets/img/myCenter/zengzhishuifapiao@3x.png'),
                invoiceHeaderGrey: require('@/assets/img/myCenter/zengzhishuifapigrey@3x.png')
            },
            textForm: [
                { label: '发票抬头', value: 'invoiceTitle' },
                { label: '税\u3000\u3000号', value: 'taxNumber' },
                { label: '发票金额', value: 'totalAmount', type: 'price' },
                { label: '发票编号', value: 'merchantOrderNo' },
                { label: '发票号码', value: 'invoiceNo' },
                { label: '发票代码', value: 'invoiceCode' },
                { label: '开票日期', value: 'invoiceDate' }
            ],
            details: {}
            // pdfSrc: {

            //     cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.2.228/cmaps/',
            //     cMapPacked: true
            // }
        };
    },
    esvReady() {
        this.routerParams = this.$route.params;
        this.queryOrderInvoice({ ...this.$route.params });
    },
    methods: {
        queryOrderInvoice(params) {
            this.$doRequest({
                url: '/invoice/queryOrderInvoice',
                params: { ...params, merchantInfo: JSON.stringify(this.merchantInfoSwitch) },
                before: function() {
                    this.loading = toastLoading();
                },
                complete: function() {
                    clearToastLoading(this.loading);
                }
            },
            (data) => {
                this.details = data.result;
            });
        },
        previewPdf() {
            window.open(this.details.invoiceUrl);
            // this.pdfShow = true;
            // this.pdfSrc.url = this.details.invoiceUrl;
            // this.pdfSrc.then(pdf => {
            //     this.numPages = pdf.numPages;
            // });
        },
        openSendInvoice() {
            this.esvOpenPage({ name: 'OPSendInvoiceEmail', params: this.routerParams });
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ]),
        invoiceHeader() {
            return this.disabled ? this.imgList.invoiceHeaderGrey : this.imgList.invoiceHeader;
        },
        disabled() {
            // return false;
            return this.details.invoiceStatus !== 'SUCCESS' || this.details.depositType === 2;
        }
    // },
    // components: {
    //     PDF
    }
};
</script>

<style lang="scss" scoped>
#membercenter {
    height: 100%;
    #main-container {
        height: 100%;
    }
}
    .header {
        width: 100%;
        height: 100px;
        background-image: linear-gradient(180deg, #EF4274 0%, #EE3556 100%);
        padding: 23px 45px 23px 36px;
        justify-content: space-between;
        display: flex;
        .left {
            color: #fff;
            .title {
                font-size: 18px;
            }
        }
        .right {
            width: 50px;
            height: 54px;
            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }

    }
    .i-container{
        margin: 16px 0;
        .invoice {
            padding: 32px 41px;
            background: url('../assets/img/myCenter/invoiceBg@3x.png') no-repeat center / contain;
            background-size: 350px 400px;
            width: 350px;
            height: 400px;
            margin: 0 auto;
            &-header {

                img {
                    margin: 0 auto;
                    width: 124px;
                    height: 40px;
                    display: block;
                }
            }
            &-container {
                margin-top: 29px;
                .invoice-item {
                    display: flex;
                    align-items: center;
                    .label {
                        font-size: 14px;
                        line-height: 40px;
                    }
                    .value {
                        text-indent: 13px;
                        color: #666;
                    }
                }
            }
        }

    }
    .van-popup {
        width: 100%;
        .pdf-box {
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            max-width: 1024px;
            width: 100%;
            margin: 0 auto;
            overflow-x: hidden;
            height: 100%;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            font-size: .28rem;
            span {
                width: 100%;
            }
        }
    }
    .btns {
        padding: 32px 25px;
    }
</style>
